import makeStyles from '@mui/styles/makeStyles';
import IconSizes from '@/constants/ui/IconSizes';

const useStyles = makeStyles((theme) => ({
  mainDialog: {
    '& .MuiDialog-paper': {
      position: 'absolute',
      right: 0,
      bottom: 0,
      margin: 0,
      background: 'transparent',
      boxShadow: 'none',
    },
  },
  contentDialog: {
    '& .MuiDialog-paperFullWidth': {
      width: '530px',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: `0 ${theme.spacing(9)} ${theme.spacing(6)} 0`,
    [theme.breakpoints.down('md')]: {
      margin: `0 ${theme.spacing(2)} ${theme.spacing(2)} 0`,
    },
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '300px',
    paddingTop: theme.spacing(2.5),
  },
  button: {
    backgroundColor: theme.palette.background.white,
  },
  buttonSmall: {
    backgroundColor: theme.palette.background.white,
    marginRight: theme.spacing(1),
  },
  icon: {
    height: IconSizes.LG,
    width: IconSizes.LG,
  },
}));

export { useStyles };
